export { OfficerPage as default } from '@/components/enpages/Company/Officer'
